export const styles = (theme: any) => ({
    expirationDateLabel: {
      fontSize: theme.font.smallFontSize,
    },
  });
